import {AutoRun_HandleBail, CreateAccessor, RunInAction} from "mobx-graphlink";
import {GetSessionsIntersectingRange_Web} from "../../Server/DB/sessions.js";
import moment from "moment";
import {MeID} from "../../Server/DB/users.js";
import {OnStoreLoaded} from "../General/GlobalHooks.js";
import {JustBeforeInitLibs} from "../../Main.js";
import {store} from "../../Store/index.js";
import {Timer} from "js-vextensions";

setTimeout(()=>AutoRun_HandleBail(()=>{
	const recentSessions = GetMyRecentSessions();
}, {name: "AccessorWarmers_RecentSessions"}));

export const GetMyRecentSessions = CreateAccessor((maxDistInDays_approximate = 3)=>{
	// use start of synthetic-day (instead of current-moment) as time-anchor, so that the range start/end times don't change each time this function calls! (since that would flood app-server with superfluous, unique requests)
	//const currentDayStart = moment(GetStartOfCurrentSyntheticDay());
	const currentDayStart = moment(store.main.timing.currentStatDay_startTime);
	const rangeStart = currentDayStart.clone().subtract(maxDistInDays_approximate, "days").valueOf();
	const rangeEnd = currentDayStart.clone().add(maxDistInDays_approximate, "days").valueOf();
	return GetSessionsIntersectingRange_Web(MeID(), rangeStart, rangeEnd);
});